module.exports = __webpack_public_path__ + "static/charcoal-84670_1920-aa075620288dc3b499f43b96c1fd5b7f.jpg";